import { render, staticRenderFns } from "./UmDbSetList.vue?vue&type=template&id=716b85cc&"
import script from "./UmDbSetList.vue?vue&type=script&lang=js&"
export * from "./UmDbSetList.vue?vue&type=script&lang=js&"
import style0 from "./UmDbSetList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports